exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup[data-v-649f697c]::after {\n  content: '';\n  top: 100%;\n  border-top: solid 10px #fff;\n  border-left: solid 12px transparent;\n  border-right: solid 12px transparent;\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  right: 0;\n  left: 0\n}\n\n", ""]);

// exports
